<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'ESTRUCOFICINA.LBL_ASIGESTRUC' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="formulario" name="nomFormulario">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6 md:col-offset-3 lg:col-offset-3">
              <div class="div-form">
                <label>* {{ 'ESTRUCOFICINA.LBL_CODIGO' | translate }}</label>
                  <label class="falso-combo-texto">{{estrucFisica.codigo}}</label>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6 md:col-offset-3 lg:col-offset-3">
              <div class="div-form">
                <label>* {{ 'ESTRUCOFICINA.LBL_ESTRFISICA' | translate }}</label>
                <label class="falso-combo-texto">{{estrucFisica.estructuraFisica}}</label>
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 md:col-3 lg:col-3 md:col-offset-3 lg:col-offset-3">
              <div class="div-form">
                <p-radioButton name="indicadorEstructura" [value]="true" id="agricola"
                               label="{{ 'ESTRUCOFICINA.LBL_ESTRAGRO' | translate}}"
                               formControlName="indicadorEstructura"
                               (onClick)="mensajeConfirmacion()"></p-radioButton>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <p-radioButton name="indicadorEstructura" [value]="false" id="pecuaria"
                               label="{{ 'ESTRUCOFICINA.LBL_ESTRPECU' | translate}}"
                               formControlName="indicadorEstructura"
                               (onClick)="mensajeConfirmacion()"></p-radioButton>
              </div>
            </div>
          </div>

          <div class="grid" *ngIf="f.indicadorEstructura.value">
            <div class="col-12 md:col-12 lg:col-12">
              <p-pickList  [source]="lisEstAgrDisponibles" filterBy="nombre"
                          [showSourceControls]="false"
                          [showTargetControls]="false"
                          [target]="lisEstAgrSeleccionadas" sourceHeader="{{ 'ESTRUCOFICINA.LBL_ESTRCREADAS' | translate}}"
                          targetHeader="{{ 'ESTRUCOFICINA.LBL_ESTRSELEC' | translate}}">
                <ng-template let-agricola pTemplate="item">
                  {{agricola.nombre}}
                </ng-template>
                <ng-template let-agricola pTemplate="emptymessagesource">
                  {{ 'LBL_SINRESULTADOS' | translate}}
                </ng-template>
                <ng-template let-agricola pTemplate="emptymessagetarget">
                  {{ 'LBL_SINRESULTADOS' | translate}}
                </ng-template>
              </p-pickList>
            </div>
          </div>

          <div class="grid" *ngIf="!f.indicadorEstructura.value">
            <div class="col-12 md:col-12 lg:col-12">
              <p-pickList  [source]="lisEstPecDisponibles" filterBy="nombre"
                          [showSourceControls]="false"
                          [showTargetControls]="false"
                          [target]="lisEstPecSeleccionadas" sourceHeader="{{ 'ESTRUCOFICINA.LBL_ESTRCREADAS' | translate}}"
                          targetHeader="{{ 'ESTRUCOFICINA.LBL_ESTRSELEC' | translate}}">
                <ng-template let-pecuaria pTemplate="item">
                  {{pecuaria.nombre}}
                </ng-template>
                <ng-template let-pecuaria pTemplate="emptymessagesource">
                  {{ 'LBL_SINRESULTADOS' | translate}}
                </ng-template>
                <ng-template let-pecuaria pTemplate="emptymessagetarget">
                  {{ 'LBL_SINRESULTADOS' | translate}}
                </ng-template>
              </p-pickList>
            </div>
          </div>


          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 text-center">
              <div *ngIf="!guardando">
                <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
                        type="button" (click)="volver()"
                        pButton></button>
              </div>
            </div>
          </div>

        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
